
import {
  ref,
  onMounted,
  onUnmounted,
  defineComponent,
  watch,
  computed,
} from 'vue';
import { ticketImageIp, blockStatus, } from '@/configs/index';
import {
  Timeline,
  Image,
} from 'ant-design-vue';
import {
  DoubleLeftOutlined,
  DoubleRightOutlined,
  EnvironmentFilled,
} from '@ant-design/icons-vue';
import moment from 'moment';

const { Item, } = Timeline;
const { PreviewGroup, } = Image;

export default defineComponent({
  components: {
    Item,
    Timeline,
    PreviewGroup,
    Image,
    EnvironmentFilled,
    DoubleLeftOutlined,
    DoubleRightOutlined,
  },
  props: {
    ticketDetail: {
      type: Object,
      default: () => ({}),
    },
  },
  setup (props, context) {
    // 流转记录数据
    const logList = ref<Array<any>>([]);
    // 工单类型：1--自动；2--手动
    const orderType = ref<any>('1');
    // 流转记录显隐
    const timelineVis = ref<boolean>(true);

    /**
     * @method changeTimelineVis 改变流转记录的显隐
     * @return {*}
     */
    const changeTimelineVis = () => {
      timelineVis.value = !timelineVis.value;
    };

    /**
     * @method getImages 获取图片资源
     * @param {*} data
     * @return {*}
     */
    const getImages = (data:any) => {
      if (!data) return [];
      const images = data.split(',').map((cur:any) => `${ticketImageIp}${cur}`);

      return images;
    };

    watch(
      () => props.ticketDetail,
      (val) => {
        if (val && val.logList) {
          logList.value = val.logList.map((cur:any) => ({ user: {}, ...cur, }));
          orderType.value = val.orderType;
        }
      },
      {
        deep: true,
        immediate: true,
      }
    );

    return {
      logList,
      orderType,
      timelineVis,
      moment,
      blockStatus,

      changeTimelineVis,
      getImages,
    };
  },
});
